export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export const DEFAULT_LANGUAGE = 'es';

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const isSupportedLanguage = (value: string | undefined): value is SupportedLanguage =>
  SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);

// Root path for a language: the default language (Spanish) lives prefix-less at
// "/", every other language under "/<lng>". Use for "go home" destinations.
export const languageRootPath = (lng: string | undefined): string =>
  !lng || lng === DEFAULT_LANGUAGE ? '/' : `/${lng}`;
